import BaseApi from "./BaseApi";

export default class CustomExportApi extends BaseApi {
  constructor() {
    if (new.target === CustomExportApi) {
      throw new TypeError("Cannot construct CustomExportApi instances directly");
    }
  }

  static getColumnsByRoster = rosterType =>
    rosterType
      ? this.get(`roster-excel-export/columns?rosterType=${rosterType}`)
      : this.get(`roster-excel-export/columns`);

  static getProfileExport = (fedTeam, rosterType, columnIds, profileIds) => {
    const fedTeamId = fedTeam.teamId || fedTeam.id || fedTeam;

    return rosterType != null
      ? this.download(
          `roster-excel-export/profile-export?rosterType=${rosterType}&fedTeamId=${fedTeamId}&columnIds=${columnIds?.join(
            ","
          )}&profileIds=${profileIds?.join(",")}`,
          null,
          null,
          "blob"
        )
      : this.download(
          `roster-excel-export/profile-export?fedTeamId=${fedTeamId}&columnIds=${columnIds?.join(
            ","
          )}&profileIds=${profileIds?.join(",")}`,
          null,
          null,
          "blob"
        );
  };
}
